import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';
import { docRecordApiRequest } from 'src/types';
import type { dynamicObj } from 'src/pages/assets';

export default class DocumentSupplierApiService extends AbstractApiService {
  public constructor({}) {
    super({});
  }

  blockSupplierForTableExtraction(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.post(api.block_supplier_table_extraction, formData);
  }

  getAllBlocked(): Promise<any> {
    return super.get(api.get_blocked_supplier_list, {});
  }

  deleteSupplier(id: string): Promise<any> {
    return super.delete(api.delete_blocked_supplier + id, {});
  }

  deleteSupplierBySupplier(supplier_id: string): Promise<any> {
    return super.delete(api.delete_by_supplier_id + supplier_id, {});
  }
}
